module.exports = __webpack_public_path__ + "static/media/next.639c8832.svg";